module.exports = __webpack_public_path__ + "img/img03.2f33a15b.png";